import { Download, Link2, Share2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";


export const PlannerSharePanel = ({
  activeDayLabel,
  importValue,
  onImportValueChange,
  onImportWeekmenu,
  onPreviewImport,
  onSaveTemplate,
  onShareLink,
  onCopyJson,
  preview,
  shareBusy,
  importBusy,
  templateBusy,
}) => {
  return (
    <section className="rounded-[28px] border border-stone-200 bg-white/90 p-4" data-testid="planner-share-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-stone-500" data-testid="planner-share-kicker">
            Shareable planner
          </p>
          <h3 className="mt-2 text-lg font-semibold text-stone-900" data-testid="planner-share-title">
            Deel een importbare link of haal een gedeeld weekmenu binnen.
          </h3>
          <p className="mt-2 text-sm text-stone-600" data-testid="planner-share-description">
            Actieve focus: {activeDayLabel}. Deeplinks openen direct de juiste dag, grocery of receptkaart.
          </p>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <Button className="rounded-full bg-stone-900 text-white hover:bg-stone-800" onClick={onShareLink} disabled={shareBusy} data-testid="planner-share-week-button">
          <Share2 className="mr-2 h-4 w-4" />
          Kopieer importlink
        </Button>
        <Button variant="outline" className="rounded-full border-stone-200 bg-white" onClick={onCopyJson} disabled={shareBusy} data-testid="planner-share-json-button">
          <Link2 className="mr-2 h-4 w-4" />
          Kopieer JSON
        </Button>
      </div>

      {preview ? (
        <div className="mt-4 rounded-[22px] border border-dashed border-emerald-200 bg-emerald-50 px-4 py-3" data-testid="planner-share-preview-card">
          <p className="text-sm font-semibold text-stone-900" data-testid="planner-share-preview-title">
            {preview.summary?.title || "Gedeeld weekmenu gevonden"}
          </p>
          <p className="mt-2 text-sm text-stone-600" data-testid="planner-share-preview-meta">
            {preview.summary?.meal_count || 0} maaltijden · focusdag {((preview.summary?.highlight_day_index ?? 0) + 1)}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <Button variant="outline" className="rounded-full border-emerald-200 bg-white" onClick={onPreviewImport} disabled={importBusy} data-testid="planner-share-preview-import-button">
              <Download className="mr-2 h-4 w-4" />
              Importeer dit weekmenu
            </Button>
            <Button variant="outline" className="rounded-full border-stone-200 bg-white" onClick={onSaveTemplate} disabled={templateBusy} data-testid="planner-share-preview-template-button">
              <Link2 className="mr-2 h-4 w-4" />
              Sla op als template
            </Button>
          </div>
        </div>
      ) : null}

      <div className="mt-4 rounded-[22px] border border-dashed border-stone-300 bg-stone-50 p-3" data-testid="planner-import-card">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-500" data-testid="planner-import-title">
          Importeer via link, code of JSON
        </p>
        <Textarea
          value={importValue}
          onChange={(event) => onImportValueChange(event.target.value)}
          placeholder="Plak hier een deelcode, volledige planner-link of JSON-export"
          className="mt-3 min-h-[112px] rounded-[22px] border-stone-200 bg-white"
          data-testid="planner-import-textarea"
        />
        <Button className="mt-3 rounded-full bg-emerald-700 text-white hover:bg-emerald-800" onClick={onImportWeekmenu} disabled={importBusy} data-testid="planner-import-button">
          <Download className="mr-2 h-4 w-4" />
          Importeer weekmenu
        </Button>
      </div>
    </section>
  );
};